import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { CoreModule } from '../core/core.module';
import { WorkshopDefectsRoutingModule } from './workshop-defects-routing.module';
import { WorkshopDefectsComponent } from './pages/workshop-defects/workshop-defects.component';
import { WorkshopDefectsNewComponent } from './pages/workshop-defects-new/workshop-defects-new.component';
import { WorkshopDefectsEditComponent } from './pages/workshop-defects-edit/workshop-defects-edit.component';
import { WorkshopDefectFormComponent } from './partials/workshop-defect-form/workshop-defect-form.component';
import { WorkshopDefectFittersComponent } from './partials/workshop-defect-fitters/workshop-defect-fitters.component';
import { WorkshopDefectPartsComponent } from './partials/workshop-defect-parts/workshop-defect-parts.component';
import { WorkshopTimelineComponent } from './pages/workshop-timeline/workshop-timeline.component';
import { WorkshopInvoicingComponent } from './pages/workshop-invoicing/workshop-invoicing.component';

@NgModule({
  declarations: [
    WorkshopDefectsComponent,
    WorkshopDefectsNewComponent,
    WorkshopDefectsEditComponent,
    WorkshopDefectFormComponent,
    WorkshopDefectFittersComponent,
    WorkshopDefectPartsComponent,
    WorkshopTimelineComponent,
    WorkshopInvoicingComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    CoreModule,
    NgSelectModule,
    WorkshopDefectsRoutingModule,
  ],
})
export class WorkshopDefectsModule { }
